import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';

export class AssetLoader {
    constructor() {
        this.textureLoader = new THREE.TextureLoader();
        this.gltfLoader = new GLTFLoader();
        this.loadedTextures = new Map();
        this.loadedModels = new Map();
    }

    async loadTexture(path) {
        if (this.loadedTextures.has(path)) {
            return this.loadedTextures.get(path);
        }

        return new Promise((resolve, reject) => {
            this.textureLoader.load(
                path,
                (texture) => {
                    this.loadedTextures.set(path, texture);
                    resolve(texture);
                },
                undefined,
                (error) => reject(error)
            );
        });
    }

    async loadModel(path) {
        if (this.loadedModels.has(path)) {
            return this.loadedModels.get(path).clone();
        }

        return new Promise((resolve, reject) => {
            this.gltfLoader.load(
                path,
                (gltf) => {
                    this.loadedModels.set(path, gltf.scene);
                    resolve(gltf.scene.clone());
                },
                undefined,
                (error) => reject(error)
            );
        });
    }

    getTexture(path) {
        return this.loadedTextures.get(path);
    }

    getModel(path) {
        const model = this.loadedModels.get(path);
        return model ? model.clone() : null;
    }
}
